import css from 'styled-jsx/css'

import { colors, sizes } from '../../../theme'
import common from '../../../theme/common'


export default css`
.container {
  display: flex;
  height: 25rem;
  justify-content: center;
  flex-direction: column;
  padding-left: 3rem;
  padding-right: 3rem;
}

.container :global(.project-link a) {
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-family: 'Taviraj-Light', serif;
  color: ${colors.pureWhite};
  font-size: 6.4rem;
}

p.title {
  ${common.big};

  font-family: 'Taviraj-Light', serif;
  color: ${colors.pureWhite};
  font-size: 4.8rem;
}

p.baseline {

  text-transform: uppercase;
  font-family: 'Nexa Light', sans-serif;
  margin-top: 0.4rem;
  font-size: 1.4rem;
  color: ${colors.pureWhite};
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .container {
    height: auto;
  }

  .container :global(.project-link a) {
    margin-top: 2rem;
    margin-bottom: 2rem;
    font-family: 'Taviraj-Light', serif;
    color: ${colors.pureWhite};
    font-size: 3.6rem;
  }

  .container :global(.project-link .icon img) {
    height: 2.4rem;
    margin-right: 0;
  }

  p.title {
    ${common.headerSmall};
  }

  p.baseline {
    margin-bottom: 2rem;
  }
}
`
